import z from "zod";

export const sortSchema = z.object({
  sortField: z
    .enum(["newest", "oldest", "az", "za", "none"])
    .default("none")
    .optional(),
  sortOrder: z.enum(["asc", "desc", "none"]).default("none").optional(),
});

export type TSort = z.infer<typeof sortSchema>;
